import React, { useEffect } from "react";
import { Modal, Form, Input, Col, Row, message } from "antd";
import { API_METHODS } from "../../../constants";
import useApi from "../../../hooks/useApi";

function UpdateSubscriptionType(props) {
  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [editResponse, editRequest] = useApi(
    `/admin/subscription-type/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      message.success("Subscription updated successfully.");
    } else if (editResponse.error) {
      close(true);
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (selectedRecord) {
          editRequest(values);
        }
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  return (
    <Modal
      title="Update Subscription"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="subscription_name"
              label="Subscription Name"
              rules={[
                { required: true, message: "Subscription Name is required." },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="price"
              label="Price"
              rules={[{ required: true, message: "Price is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default UpdateSubscriptionType;
